module.exports = __webpack_public_path__ + "media/images/secret_ic-d66c9fc7b8345d21757033495017f183.svg";